<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>
        <!-- 検索条件 -->
        <div class="group-box">
          <span class="box-title">検索条件</span>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-start">
              有効期間
            </v-col>
            <v-col cols="2" class="mr-0 search-date">
              <v-menu
                v-model="menuSrtValidityperiodDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="srtValidityperiodDate"
                    label="開始日"
                    persistent-hint
                    clearable
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="srtValidityperiodDate"
                  @input="menuSrtValidityperiodDateFlg = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1" class="d-flex align-center justify-start" style="max-width: 20px">
              <span >～</span>
            </v-col>
            <v-col cols="2 search-date">
              <v-menu
                v-model="menuEndValidityperiodDateFlg"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="endValidityperiodDate"
                    label="終了日"
                    persistent-hint
                    clearable
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endValidityperiodDate"
                  @input="menuEndValidityperiodDateFlg = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="1"> </v-col>
            <v-col cols="1" class="d-flex align-center justify-start">
              ユーザ番号
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="srchCndUserNo"
                label=""
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="3"> </v-col>
          </v-row>

          <v-row dense>
            <v-col cols="1" class="d-flex align-center justify-start">
              氏名
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="srchCndName"
                label="フリガナまたは漢字の前方一致"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="6"> </v-col>
            <v-col cols="2">
              <v-btn
                x-large
                color="indigo darken-1"
                dark
                min-width="180px"
                @click="search()"
                >{{ $t("LCM001") }}</v-btn
              >
            </v-col>
          </v-row>
        </div>

        <!-- 検索結果一覧 -->
        <v-data-table
          :headers="headers"
          :items="desserts"
          item-key="no"
          :items-per-page="10"
          loading-text="Loading... Please wait"
          class="v-dtbl-md-1 v-dtbl-head-md-1 v-dtbl-body-md-1 elevation-1"
          :no-data-text="$t('webmsg.common.datatblenodata')"
        >
          <template v-slot:[`item.edit`]="{ item }">
            <v-row>
              <v-col cols="6">
                <v-btn small color="indigo darken-1" dark min-width="80px" @click="dispModifyView(item.userId)">{{ $t("LCM003") }}</v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn small color="red" dark min-width="80px" @click="deleteUser(item)">{{ $t("LCM004") }}</v-btn>
              </v-col>
            </v-row>
          </template>

        </v-data-table>
      </v-container>
    </v-main>
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comMessageConfirm :msg="dlgMsgConfirmDel.msg" :isOpen="dlgMsgConfirmDel.isOpen" :doYes="dlgMsgConfirmDel.doYes" :doNo="dlgMsgConfirmDel.doNo" />
 
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "MainteAccountListSearch",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: " 管理ユーザ一覧検索",
      screenId: "MTO220",
      messageArea: "",
      srtValidityperiodDate: new Date().toISOString().substr(0, 10),
      endValidityperiodDate: new Date().toISOString().substr(0, 10),
      menuSrtValidityperiodDateFlg: false,
      menuEndValidityperiodDateFlg: false,
      headers: [
          { text: "No", align: "start", value: "no", width: "5%" },
          { text: 'ユーザ番号', align: 'start', sortable: true, value: 'userNo', width: "15%" },
          { text: '氏名', align: 'start', sortable: true, value: 'name', width: "20%" },
          { text: '有効期間', align: 'center', sortable: true, value: 'validityperiodDate', width: "20%" },
          { text: '編集', align: 'center', sortable: false, value: 'edit', width: "15%" },
      ],
      desserts: [],
      srchCndUserNo: "",
      srchCndName: "",
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.search();
        },
      },
    dlgMsgConfirmDel: {
        msg: this.$i18n.t('msg.wrn.cm011'),
        value:"",
        isOpen: false,
        doYes: () => {
          this.suspend(this.dlgMsgConfirmDel.value);
          this.dlgMsgConfirmDel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmDel.isOpen = false;
        },
      },
    };
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'MTO210') {
      this.$store.commit("mainteAccountListSearch/resetState");
    }
    next();
  },
  methods: {
    /*
     * 初期表示
     */
    initialize() {
      this.setAuthUserInfo();
      // 画面説明メッセージ
      this.messageArea = this.$i18n.t('webmsg.mto220.area');
       // 再検索
      this.reSearch();
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },
    /**
     * 「検索」ボタン押下
     */
    search: async function() {
       // 管理ユーザ一覧検索サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      let apiurl = Constants.URL_API_MTO220P01;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        // 入力データ
        let searchCondition = this.managerInfoListSearchData();
        let data = JSON.stringify(searchCondition);
        // API呼出
        let response = await this.$axios.post(apiurl,data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        console.log(response);
        responseData = response.data
        this.displyManagerInfoList(responseData);
        // 画面用データストア(検索条件)登録
        this.$store.dispatch("mainteAccountListSearch/setSearchCondition", searchCondition);
      } catch(error) {
          console.log(error);
          apiErrorInfo = error;
      } 
      // 検索完了メッセージ表示
      this.showDialogMsgAfterSearchAPICall(this.dlgMsg, apiErrorInfo, responseData);
    },

    /**
     * 再検索処理
     */
    reSearch: function() {
      // 画面用データストア(検索条件)取得
      let searchCondition = this.$store.getters["mainteAccountListSearch/getSearchCondition"];
      if (searchCondition == null || !Object.keys(searchCondition).length) {
        return;
      }
      // 検索条件復元
      this.srtValidityperiodDate = searchCondition['validityperiodStartDate'];
      this.endValidityperiodDate = searchCondition['validityperiodEndDate'];
      this.srchCndName = searchCondition['name'];
      this.srchCndUserNo = searchCondition['userNo'];
      // 再検索
      this.search();
    },

   /*
    * 検索用リクエストデータ生成
    */
    managerInfoListSearchData : function() {
      let reqData = {};
      reqData['validityperiodStartDate'] = this.srtValidityperiodDate;
      reqData['validityperiodEndDate'] = this.endValidityperiodDate;
      reqData['name'] = this.srchCndName;
      reqData['userNo'] = this.srchCndUserNo;
      
      return reqData;
    },

    /*
    * 管理ユーザ情報一覧表示
    */
    displyManagerInfoList : function(responseData) {
      this.desserts = new Array();
      if (responseData.data == null) {
        return;
      }
      let searchResultList = responseData.data.managerInfoListSeachResultDtoList;
      if (Utils.isEmptyArry(searchResultList)) {
        return;
      } 
      let request;
      for (const value of searchResultList) {
        request = {};
        request['no'] = value.displayNo ;
        request['userNo'] = value.userNo;
        request['name'] = value.name;
        request['userId'] = value.userId ;
        request['validityperiodDate'] = value.dispValidityperiodStartDate + ' ～ ' + value.dispValidityperiodEndDate ;

        request['updateUserId'] = value.updateUserId ;
        request['updateDatetime'] = value.updateDatetime ;
        this.desserts.push(request);
      }
    },

    /*
    * 検索完了メッセージ表示
    */
    showDialogMsgAfterSearchAPICall : function(dialog, apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        dialog.msg = this.$i18n.t('msg.err.cm100', ['管理ユーザ一覧']);
        dialog.isOpen = true;
        this.desserts.push({});
        return hasError;
      }
      // API処理異常
      if (responseData.statusCd === 500) {
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          dialog.msg = Utils.createMsgViewStringForErrList(errorList);
          dialog.isOpen = true;
          this.desserts.push({});
          return hasError;
        }else{
          dialog.msg = responseData.message ;
          dialog.isOpen = true;
          this.desserts.push({});
         return hasError;
        }
      }
    },

    /**
     * 「削除」ボタン押下
     */
    deleteUser(suspendItem) {
      this.dlgMsgConfirmDel.value = suspendItem;
      this.dlgMsgConfirmDel.isOpen = true;
    },


    /**
     * 管理ユーザ削除処理
     */
    suspend: async function(suspendItem) {
       //管理ユーザ削除サービス呼び出し
       let responseData = null;
       let apiErrorInfo = null;
       let apiurl = Constants.getUrlApiMTO220P02(suspendItem.userId);
       let accessToken = this.$store.getters["authcUser/getAccessToken"];
       try {
           // 入力データ
           let data = JSON.stringify(this.managersuspendData(suspendItem));
           // API呼出
           let response = await this.$axios.put(apiurl,data,
           {
               headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
               responseType: "json",
            });
            console.log(response);
            responseData = response.data
        } catch(error) {
            console.log(error);
            apiErrorInfo = error;
        } 

        // 削除完了メッセージ表示
        this.showDialogMsgAfterSuspendAPICall(apiErrorInfo, responseData);
    },

/*
    * 削除用リクエストデータ生成
    */
    managersuspendData : function(suspendItem) {
      let reqData = {};
      reqData['userId'] = suspendItem.userId;
      reqData['updateDatetime'] = suspendItem.updateDatetime;
      reqData['updateUserId'] = suspendItem.updateUserId;
      return reqData;
    },

    /*
    * 削除完了メッセージ表示
    */
    showDialogMsgAfterSuspendAPICall : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm113', ['ユーザ']);
        this.dlgMsg.isOpen = true;
        this.desserts.push({});
        return hasError;
      }

      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        this.dlgMsgCompd.msg = responseData.message ;
        this.dlgMsgCompd.isOpen = true;
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          this.desserts.push({});
          return hasError;
        }else{
          this.dlgMsg.msg = responseData.message ;
          this.dlgMsg.isOpen = true;
          this.desserts.push({});
          return hasError;
        }
      }
    },

    /**
     * 変更画面遷移
     */
    dispModifyView(selectedUserNo) {
        this.$router.push(this.$router.resolve({ name: "MTO210", params: {userNo: selectedUserNo} }).href);
    },

    
  },
};
</script>

<style scoped>
.group-box {
  position: relative;
  margin: 1.5em 0;  padding: 0.3em 2em;
  border: solid 2px #141414;
  border-radius: 8px;
}
.group-box .box-title {
  position: absolute;
  display: inline-block;
  top: -13px;
  left: 10px;
  padding: 0 9px;
  line-height: 1;
  font-size: 18px;
  background: #fff;
  color: #0b0c0c;
  font-weight: bold;
}
.group-box p {
  margin: 0;
  padding: 0;
}
.search-date {
  max-width: 160px;
}
</style>
